
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import ReactHtmlParser from "react-html-parser";
import htmlToDraft from "html-to-draftjs";
import ReactImageUploading from "react-images-uploading";
import ReactDatePicker from "react-datepicker";
import { Link, useParams } from "react-router-dom";

import moment from "moment";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* TOAST NOTIFICATION */
import { toast } from "react-toast";

/* REDUX IMPORTS */
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/actions/userAction";

/* FORM CONTROL */
import { useFormik } from "formik";
import * as yup from "yup";

/* REACT ICONS */
import { AiFillPlusCircle } from "react-icons/ai";
import { FiTrash } from "react-icons/fi";

/* USER DEFINED COMPONENTS */
import InputField from "../../../components/input";

/* API IMPORT */
import {
 
  getProductList,
  getProductDetailsById,
  editProductDetailsById,
  deleteProductImageByProductImageId,
  addProductImageByProductId,
 
} from "../../../service/api/product.api";
import {
  getCategoryList,
 
 
} from "../../../service/api/category.api";
import {
  
  getTagList,
} from "../../../service/api/tag.api";
import { IMAGE_URL } from "../../../config";
import { handleAddToken } from "../../../service/request";

/* STATUS OPTIONS */
const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "In-Active" },
  { value: "comingSoon", label: "Coming Soon" },
];

/* Validation Schema */
// Validation Schema For PromoCode Add Form
const validationSchema = yup.object().shape({
  sku: yup.string().required(),
  hsn: yup.string(),
  name: yup.string().required(),
  description: yup.mixed().required(),
  shortDescription: yup.string(),
  howToUse: yup.mixed(),
  ingredients: yup.mixed(),
  amount: yup.number().required(),
  color: yup.string().required(),
  specialAmount: yup.number(),
  specialAmountStartDate: yup.date(),
  specialAmountEndDate: yup.date(),
  weight: yup.number().required(),
  quantity: yup.number().required(),
  category: yup.array().required(),
  subCategory: yup.array(),
  tag: yup.array(),
  metaTagsTitle: yup.string(),
  metaTagsKeyWords: yup.string(),
  metaTagsDescription: yup.string(),
  youtubeLinks: yup.array(),
  isFeatured: yup.boolean(),
  isMenu: yup.boolean(),
  status: yup.string().required(),
});

const EditProduct = () => {
  // GLOBAL VARIABLES
  const { id } = useParams();
  const userDetails = useSelector((state) => state?.user);

  // STATE VARIABLES
  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [tagList, setTagList] = useState([]);

  const [productDetails, setProductDetails] = useState(null);

  const [productImages, setProductImages] = useState([]);

  const [uploading, setUploading] = useState(false);

  const [productFrontImages, setProductFrontImages] = useState([]);
  const [productBackImages, setProductBackImages] = useState([]);
  const [productOthersImages, setProductOthersImages] = useState([]);

  /* CHOOSE IMAGES */
  const onFrontImageChange = (imageList) => {
    setProductFrontImages(imageList);
  };
  const onBackImageChange = (imageList) => {
    setProductBackImages(imageList);
  };
  const onOtherImageChange = (imageList) => {
    setProductOthersImages(imageList);
  };

  // Formik Function For Edit Product
  const editFormikFunction = useFormik({
    initialValues: {
      sku: "",
      hsn: "330300",
      name: "",
      description: EditorState.createEmpty(),
      shortDescription: "",
      howToUse: EditorState.createEmpty(),
      ingredients: EditorState.createEmpty(),
      amount: "",
      color: "",
      specialAmount: "",
      specialAmountStartDate: "",
      specialAmountEndDate: "",
      weight: "",
      quantity: "",
      category: "",
      subCategory: "",
      tag: "",
      metaTagsTitle: "",
      metaTagsKeyWords: "",
      metaTagsDescription: "",
      youtubeLinks: "",
      isFeatured: "",
      isMenu: "",
      status: "active",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const obj = {};

      if (values?.sku !== "") {
        obj.sku = values?.sku;
      }
      if (values?.hsn !== "") {
        obj.hsn = values?.hsn;
      }
      if (values?.name !== "") {
        obj.name = values?.name;
      }
      if (values?.description !== "") {
        obj.description = draftToHtml(
          convertToRaw(values?.description?.getCurrentContent())
        );
      }
      if (values?.shortDescription !== "") {
        obj.shortDescription = values?.shortDescription;
      }
      if (values?.howToUse !== "") {
        obj.howToUse = draftToHtml(
          convertToRaw(values?.howToUse?.getCurrentContent())
        );
      }
      if (values?.ingredients !== "") {
        obj.ingredients = draftToHtml(
          convertToRaw(values?.ingredients?.getCurrentContent())
        );
      }
      if (values?.amount !== "") {
        obj.amount = values?.amount;
      }
      if (values?.color !== "") {
        obj.color = values?.color;
      }
      if (values?.specialAmount !== "") {
        obj.specialAmount = values?.specialAmount;
      }
      if (values?.specialAmountStartDate !== "") {
        obj.specialAmountStartDate = values?.specialAmountStartDate;
      }
      if (values?.specialAmountEndDate !== "") {
        obj.specialAmountEndDate = values?.specialAmountEndDate;
      }

      if (values?.weight !== "") {
        obj.weight = values?.weight;
      }
      if (values?.quantity !== "") {
        obj.quantity = values?.quantity;
      }
      if (values?.metaTagsTitle !== "") {
        obj.metaTagsTitle = values?.metaTagsTitle;
      }
      if (values?.metaTagsKeyWords !== "") {
        obj.metaTagsKeyWords = values?.metaTagsKeyWords;
      }
      if (values?.metaTagsDescription !== "") {
        obj.metaTagsDescription = values?.metaTagsDescription;
      }
      if (values?.status !== "") {
        obj.status = values?.status;
      }

      let tempArray = [];
      values?.category?.forEach((el) => {
        tempArray.push(el?.value);
      });
      obj.category = tempArray;

      setLoading(true);
      editProductDetailsById(id, obj)
        .then((res) => {
          if (res?.status) {
            toast.success(res?.message);
            // editFormikFunction.resetForm();
            setLoading(!loading);
          } else {
            console.log(res?.message);
            toast.error(res?.message);
          }
        })
        .catch((e) => {
          setLoading(false);
          toast.error(e?.response?.data?.message);
        })
        .finally((res) => {
          setLoading(false);
        });
    },
  });

  // Functions
  const productsGetFunction =async () => {
    await handleAddToken(userDetails?.token);
    const obj = {
      page: 1,
      sizePerPage: 1,
      pagination: false,
    };
    getProductList(obj)
      .then((response) => {
        if (response?.status) {
          console.log("response", response);
          let tempArray = [];
          response?.data?.forEach((element) => {
            tempArray?.push({ value: element?._id, label: element?.name });
          });
          setProductsList(tempArray);
        }
      })
      .finally(() => {
        // setLoading(false);
      });
  };
  const categoriesGetFunction = async () => {
    await handleAddToken(userDetails?.token);
    const obj = {
      page: 1,
      sizePerPage: 1,
      pagination: false,
      category: "all",
    };
    getCategoryList(obj)
      .then((response) => {
        if (response?.status) {
          console.log("response", response);
          let tempArray = [];
          response?.data?.forEach((element) => {
            tempArray?.push({ value: element?._id, label: element?.name });
          });
          setCategoryList(tempArray);
        }
      })
      .finally(() => {
        // setLoading(false);
      });
  };
  const tagsGetFunction = async () => {
    await handleAddToken(userDetails?.token);
    const obj = {
      page: 1,
      sizePerPage: 1,
      pagination: false,
    };
    getTagList(obj)
      .then((response) => {
        if (response?.status) {
          console.log("response", response);
          let tempArray = [];
          response?.data?.forEach((element) => {
            tempArray?.push({
              value: element?._id,
              label: element?.name,
            });
          });
          setTagList(tempArray);
        }
      })
      .finally(() => {
        // setLoading(false);
      });
  };
  const handleGetProductDetails = async () => {
    await handleAddToken(userDetails?.token);
    getProductDetailsById(id)
      .then((res) => {
        toast.success(res?.message);
        setProductDetails(res?.data);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRemoveImage = (imageId) => {
    deleteProductImageByProductImageId(id, imageId)
      .then((res) => {
        toast.success(res?.message);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        handleGetProductDetails();
      });
  };

  const handleAddProductImage = (imageUploadType) => {
    setUploading(true);
    const formData = new FormData();

    formData.append("imageFor", imageUploadType);

    if (productFrontImages?.[0]?.file && imageUploadType === "front") {
      formData.append("image", productFrontImages?.[0]?.file);
    }
    if (productBackImages?.[0]?.file && imageUploadType === "back") {
      formData.append("image", productBackImages?.[0]?.file);
    }

    if (productOthersImages?.[0]?.file && imageUploadType === "others") {
      formData.append("image", productOthersImages?.[0]?.file);
    }
    addProductImageByProductId(id, formData)
      .then((res) => {
        toast.success(res?.message);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        setUploading(false);
        handleGetProductDetails();
        if (imageUploadType === "front") {
          setProductFrontImages([]);
        } else if (imageUploadType === "back") {
          setProductBackImages([]);
        } else if (imageUploadType === "others") {
          setProductOthersImages([]);
        }
      });
  };

  useEffect(() => {
    productsGetFunction();
    categoriesGetFunction();
    tagsGetFunction();
  }, []);

  useEffect(() => {
    if (id) {
      handleGetProductDetails();
    }
  }, [id]);

  useEffect(() => {
    if (productDetails && categoryList && tagList) {
      editFormikFunction.setFieldValue("sku", productDetails?.sku);
      const isCandleProduct =
        (productDetails?.name || "").toLowerCase().includes("candle") ||
        (Array.isArray(productDetails?.category) &&
          productDetails.category.some((c) =>
            typeof c === "object"
              ? (c?.name || "").toLowerCase().includes("candle")
              : false
          ));
      editFormikFunction.setFieldValue(
        "hsn",
        productDetails?.hsn || (isCandleProduct ? "340600" : "330300")
      );
      editFormikFunction.setFieldValue("name", productDetails?.name);

      editFormikFunction.setFieldValue(
        "description",
        EditorState.createWithContent(
          ContentState.createFromBlockArray(
            htmlToDraft(productDetails?.description ?productDetails?.description : '<p></p>')?.contentBlocks,
            htmlToDraft(productDetails?.description ?productDetails?.description : '<p></p>')?.entityMap
          )
        )
      );
      editFormikFunction.setFieldValue(
        "shortDescription",
        productDetails?.shortDescription
      );

      // editFormikFunction.setFieldValue(
      //   "howToUse",
      //   EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(<p style="text-align:start;"></p>)?.contentBlocks, htmlToDraft(<p style="text-align:start;"></p>)?.entityMap))
      // );
      editFormikFunction.setFieldValue(
        "ingredients",
        EditorState.createWithContent(
          ContentState.createFromBlockArray(
            htmlToDraft(productDetails?.ingredients ?productDetails?.ingredients : '<p></p>')?.contentBlocks,
            htmlToDraft(productDetails?.ingredients ?productDetails?.ingredients : '<p></p>')?.entityMap
          )
        )
      );
      editFormikFunction.setFieldValue("amount", productDetails?.amount);

      editFormikFunction.setFieldValue(
        "specialAmount",
        productDetails?.specialAmount?.amount
      );
      editFormikFunction.setFieldValue(
        "specialAmountStartDate",
        productDetails?.specialAmount?.startDate
      );
      editFormikFunction.setFieldValue(
        "specialAmountEndDate",
        productDetails?.specialAmount?.endDate
      );

      editFormikFunction.setFieldValue("weight", productDetails?.weight);
      editFormikFunction.setFieldValue("quantity", productDetails?.quantity);
      let tempArray = [];
      productDetails?.category?.forEach((el) => {
        tempArray.push(
          categoryList?.find((element) => element?.value === el?._id)
        );
      });
      editFormikFunction.setFieldValue("category", tempArray);

      let tempTagArray = [];
      productDetails?.tag?.forEach((el) => {
        tempTagArray.push(
          tagList?.find((element) => element?.value === el?._id)
        );
      });
      editFormikFunction.setFieldValue("tag", tempTagArray);

      editFormikFunction.setFieldValue(
        "metaTagsTitle",
        productDetails?.metaTags?.title
      );
      editFormikFunction.setFieldValue(
        "metaTagsKeyWords",
        productDetails?.metaTags?.keyWords
      );
      editFormikFunction.setFieldValue(
        "metaTagsDescription",
        productDetails?.metaTags?.description
      );
    }
  }, [productDetails, categoryList, tagList]);

  return (
    <section className="px-0 py-2 xl:p-10 lg:p-10 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Edit Product | CIDA Perfumes</title>
      </Helmet>

      <div className="container-full-width">
        <form onSubmit={editFormikFunction.handleSubmit}>
          {/* HEADING */}
          <div className="block xl:flex lg:flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-proxima-bold text-black tracking-tight">
                Edit Product
              </h1>
              <h2 className="text-base xl:text-lg lg:text-lg font-proxima-regular text-greyText tracking-tight">
                Fill in the following details to add the product in the
                inventory
              </h2>
            </div>
            <div className="flex items-center gap-2 mt-2 xl:mt-0 lg:mt-0">
              <Link to="/inventory">
                <Button className="w-full xl:w-auto lg:w-auto whitespace-nowrap xl:whitespace-normal lg:whitespace-normal shadow-none hover:shadow-none bg-white hover:bg-black hover:bg-opacity-5 px-5 py-3 rounded-md border border-authBorder text-sm font-proxima-semibold text-black normal-case transition-all duration-300 ease-in-out">
                  Back to Inventory
                </Button>
              </Link>
              <Button
                type="submit"
                disabled={loading}
                className="w-full xl:w-auto lg:w-auto whitespace-nowrap xl:whitespace-normal lg:whitespace-normal shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-5 py-3 rounded-md border border-logoYellow text-sm font-proxima-semibold text-white normal-case transition-all duration-300 ease-in-out"
              >
                {loading ? "Please wait..." : "Save details"}
              </Button>
            </div>
          </div>

          {/* FORM */}

          <div className="mt-5">
            <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-5 xl:gap-5 lg:gap-5">
              {/* DETAILS */}
              <div className="col-span-2">
                <div className="bg-white rounded-lg border border-authBorder">
                  <div className="px-5 py-3 border-b border-authBorder">
                    <h5 className="text-lg font-proxima-bold text-black">
                      Product Details
                    </h5>
                    <p className="text-sm font-proxima-regular text-greyText">
                      Fill in these product specific details
                    </p>
                  </div>
                  <div className="p-5">
                    <form>
                      <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
                        {/* NAME */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Product Name{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <InputField
                                type="text"
                                name="name"
                                id="name"
                                onChange={editFormikFunction.handleChange}
                                value={editFormikFunction.values.name}
                                error={
                                  editFormikFunction.errors.name &&
                                  editFormikFunction.touched.name
                                    ? true
                                    : false
                                }
                                placeholder="Write the product name"
                              />
                            </div>
                          </div>
                        </div>

                        {/* SKU */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Product SKU{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <InputField
                                type="text"
                                name="sku"
                                id="sku"
                                onChange={editFormikFunction.handleChange}
                                value={editFormikFunction.values.sku}
                                error={
                                  editFormikFunction.errors.sku &&
                                  editFormikFunction.touched.sku
                                    ? true
                                    : false
                                }
                                placeholder="Write the product sku"
                              />
                            </div>
                          </div>
                        </div>

                        {/* HSN CODE */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              HSN Code
                            </label>
                            <div className="mt-1">
                              <InputField
                                type="text"
                                name="hsn"
                                id="hsn"
                                onChange={editFormikFunction.handleChange}
                                value={editFormikFunction.values.hsn}
                                error={
                                  editFormikFunction.errors.hsn &&
                                  editFormikFunction.touched.hsn
                                    ? true
                                    : false
                                }
                                placeholder="e.g. 330300"
                              />
                            </div>
                          </div>
                        </div>

                        {/* WEIGHT */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Product Weight{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <InputField
                                type="number"
                                name="weight"
                                id="weight"
                                onChange={editFormikFunction.handleChange}
                                value={editFormikFunction.values.weight}
                                error={
                                  editFormikFunction.errors.weight &&
                                  editFormikFunction.touched.weight
                                    ? true
                                    : false
                                }
                                placeholder="Write the product weight"
                              />
                            </div>
                          </div>
                        </div>

                        {/* AMOUNT */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Product Price (₹){" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <InputField
                                type="number"
                                name="amount"
                                id="amount"
                                onChange={editFormikFunction.handleChange}
                                value={editFormikFunction.values.amount}
                                error={
                                  editFormikFunction.errors.amount &&
                                  editFormikFunction.touched.amount
                                    ? true
                                    : false
                                }
                                placeholder="Write the product price"
                              />
                            </div>
                          </div>
                        </div>

                        {/* QUANTITY */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Stock in inventory{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <InputField
                                type="number"
                                name="quantity"
                                id="quantity"
                                onChange={editFormikFunction.handleChange}
                                value={editFormikFunction.values.quantity}
                                error={
                                  editFormikFunction.errors.quantity &&
                                  editFormikFunction.touched.quantity
                                    ? true
                                    : false
                                }
                                placeholder="Write the stock in inventory"
                              />
                            </div>
                          </div>
                        </div>

                        {/* CATEGORY */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Product Category{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <Select
                                options={categoryList}
                                placeholder="Select category"
                                name="productCategory"
                                id="productCategory"
                                isMulti
                                classNamePrefix={
                                  editFormikFunction.errors.category &&
                                  editFormikFunction.touched.category
                                    ? "dropdown_error"
                                    : "dropdown"
                                }
                                onChange={(event) =>
                                  editFormikFunction.setFieldValue(
                                    "category",
                                    event
                                  )
                                }
                                value={editFormikFunction.values.category}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="grid grid-cols-4 gap-3">
                            {/* COLOR */}
                            <div className="col-span-6 xl:col-span-3 lg:col-span-3">
                              <div className="form-group">
                                <label className="text-sm font-proxima-semibold text-black">
                                  Product Tag{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <div className="mt-1">
                                  <Select
                                    options={tagList}
                                    placeholder="Select Tag"
                                    name="tag"
                                    id="tag"
                                    classNamePrefix={
                                      editFormikFunction.errors.tag &&
                                      editFormikFunction.touched.tag
                                        ? "dropdown_error"
                                        : "dropdown"
                                    }
                                    onChange={(event) =>
                                      editFormikFunction.setFieldValue(
                                        "tag",
                                        event?.value
                                      )
                                    }
                                    value={tagList?.find(
                                      (el) =>
                                        el?.value ===
                                        editFormikFunction.values.tag
                                    )}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* STATUS */}
                            <div className="col-span-6 xl:col-span-1 lg:col-span-1">
                              <div className="form-group">
                                <label className="text-sm font-proxima-semibold text-black">
                                  Product Status{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <div className="mt-1">
                                  <Select
                                    options={statusOptions}
                                    classNamePrefix={
                                      editFormikFunction.errors.status &&
                                      editFormikFunction.touched.status
                                        ? "dropdown_error"
                                        : "dropdown"
                                    }
                                    placeholder="Select Status"
                                    name="status"
                                    id="status"
                                    onChange={(event) =>
                                      editFormikFunction.setFieldValue(
                                        "status",
                                        event?.value
                                      )
                                    }
                                    value={statusOptions?.find(
                                      (el) =>
                                        el?.value ===
                                        editFormikFunction.values.status
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* SHORT DESCRIPTION */}
                        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Short Description{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <InputField
                                type="text"
                                name="shortDescription"
                                id="shortDescription"
                                onChange={editFormikFunction.handleChange}
                                value={
                                  editFormikFunction.values.shortDescription
                                }
                                error={
                                  editFormikFunction.errors.shortDescription &&
                                  editFormikFunction.touched.shortDescription
                                    ? true
                                    : false
                                }
                                placeholder="Write the product short Description"
                              />
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-span-2">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Product Tags <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <Select
                                options={tags}
                                isMulti
                                classNamePrefix="dropdown"
                                placeholder="Select tags"
                                name="tags"
                                id="tags"
                              />
                            </div>
                          </div>
                        </div> */}
                        <div className="col-span-2">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black h-96">
                              Product Description{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <Editor
                                toolbar={{
                                  options: [
                                    "inline",
                                    "blockType",
                                    "list",
                                    "link",
                                  ],
                                  inline: {
                                    options: ["bold", "italic", "underline"],
                                  },
                                  list: { options: ["unordered", "ordered"] },
                                }}
                                wrapperClassName={
                                  editFormikFunction.errors.description &&
                                  editFormikFunction.touched.description
                                    ? "text-editor-wrapper-error"
                                    : "text-editor-wrapper"
                                }
                                editorClassName="editorClassName"
                                onEditorStateChange={(e) => {
                                  editFormikFunction.setFieldValue(
                                    "description",
                                    e
                                  );
                                }}
                                editorState={
                                  editFormikFunction.values.description
                                }
                                placeholder="Write the product description here"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              Product Ingredients{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <Editor
                                toolbar={{ options: ["inline", "link"] }}
                                editorClassName="text-editor h-auto"
                                wrapperClassName={
                                  editFormikFunction.errors.ingredients &&
                                  editFormikFunction.touched.ingredients
                                    ? "text-editor-wrapper-error"
                                    : "text-editor-wrapper"
                                }
                                onEditorStateChange={(e) => {
                                  editFormikFunction.setFieldValue(
                                    "ingredients",
                                    e
                                  );
                                }}
                                editorState={
                                  editFormikFunction.values.ingredients
                                }
                                placeholder="Write the product ingredients here"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-span-1">
                          <div className="form-group">
                            <label className="text-sm font-proxima-semibold text-black">
                              How to use <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-1">
                              <Editor
                                toolbar={{ options: ["inline", "link"] }}
                                editorClassName="text-editor h-auto"
                                // wrapperClassName={editFormikFunction.errors.howToUse && editFormikFunction.touched.howToUse ? "text-editor-wrapper-error" : "text-editor-wrapper"}

                                // onEditorStateChange={(e) => {
                                //   editFormikFunction.setFieldValue("howToUse", e);
                                // }}

                                // editorState={editFormikFunction.values.howToUse}
                                placeholder="Write the product How to Use here"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-5">
                          <div className="col-span-1">
                            <div className="form-group">
                              <label className="text-sm font-proxima-semibold text-black">
                                Meta Title
                              </label>
                              <div className="mt-1">
                                <InputField
                                  type="text"
                                  name="metaTagsTitle"
                                  id="metaTagsTitle"
                                  onChange={editFormikFunction.handleChange}
                                  value={
                                    editFormikFunction.values.metaTagsTitle
                                  }
                                  error={
                                    editFormikFunction.errors.metaTagsTitle &&
                                    editFormikFunction.touched.metaTagsTitle
                                      ? true
                                      : false
                                  }
                                  placeholder="Write the Meta Title"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-span-1">
                            <div className="form-group">
                              <label className="text-sm font-proxima-semibold text-black">
                                Meta Keywords
                              </label>
                              <div className="mt-1">
                                <InputField
                                  type="text"
                                  name="metaTagsKeyWords"
                                  id="metaTagsKeyWords"
                                  onChange={editFormikFunction.handleChange}
                                  value={
                                    editFormikFunction.values.metaTagsKeyWords
                                  }
                                  error={
                                    editFormikFunction.errors
                                      .metaTagsKeyWords &&
                                    editFormikFunction.touched.metaTagsKeyWords
                                      ? true
                                      : false
                                  }
                                  placeholder="Write the Meta Keywords"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="text-sm font-proxima-semibold text-black">
                            Meta Description
                          </label>
                          <div className="mt-1">
                            <InputField
                              type="text"
                              name="metaTagsDescription"
                              id="metaTagsDescription"
                              onChange={editFormikFunction.handleChange}
                              value={
                                editFormikFunction.values.metaTagsDescription
                              }
                              error={
                                editFormikFunction.errors.metaTagsDescription &&
                                editFormikFunction.touched.metaTagsDescription
                                  ? true
                                  : false
                              }
                              placeholder="Write the Meta Description"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* IMAGES AND DISCOUNTS */}
              <div className="col-span-1">
                {/* PRODUCT IMAGES */}
                <div className=" bg-white rounded-lg border border-authBorder">
                  <div className="px-5 py-3 border-b border-authBorder">
                    <h5 className="text-lg font-proxima-bold text-black">
                      Product Images
                    </h5>
                    <p className="text-sm font-proxima-regular text-greyText">
                      Attach the product images for this product
                    </p>
                  </div>
                  {/* FRONT IMAGE */}
                  <div className="p-5">
                    <div className="block xl:flex lg:flex items-center justify-between">
                      <div>
                        <h5 className="text-lg font-proxima-bold text-black mb-3">
                          Front Image
                        </h5>
                      </div>
                      {productFrontImages?.length > 0 && (
                        <div className="flex items-center gap-2  xl:mt-0 lg:mt-0">
                          <Button
                            onClick={() => {
                              handleAddProductImage("front");
                            }}
                            disabled={uploading}
                            className="w-full xl:w-auto lg:w-auto whitespace-nowrap xl:whitespace-normal lg:whitespace-normal shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-4 py-2 rounded-md border border-logoYellow text-xs font-proxima-semibold text-white normal-case transition-all duration-300 ease-in-out"
                          >
                            {uploading ? "Please wait..." : "Upload Image"}
                          </Button>
                        </div>
                      )}
                    </div>
                    {productDetails?.image?.front?.url ? (
                      <div className="grid grid-cols-2 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                        <div className="col-span-1 relative">
                          <img
                            src={IMAGE_URL+ productDetails?.image?.front?.url}
                            className="w-full h-productImage object-cover rounded-md"
                            alt="Product"
                          />
                          <div className="absolute top-2 right-2">
                            <Button
                              className="p-2 rounded-full shadow-none hover:shadow-none bg-white border border-logoYellow"
                              onClick={() => handleRemoveImage("front")}
                            >
                              <FiTrash className="w-3 h-3 text-black" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <ReactImageUploading
                        multiple
                        value={productFrontImages}
                        onChange={onFrontImageChange}
                        maxNumber={5}
                        dataURLKey="data_url"
                      >
                        {({ imageList, onImageUpload, onImageRemove }) => (
                          <div className="grid grid-cols-2 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                            <div className="col-span-1">
                              <div
                                className="w-full h-productImage rounded-md bg-[#F5F5F5] bg-opacity-50 border border-authBorder cursor-pointer hover:border-logoYellow transition-all duration-300 ease-in-out p-5"
                                onClick={onImageUpload}
                              >
                                <AiFillPlusCircle className="w-8 h-8 text-greyText mx-auto" />
                                <div className="mt-2">
                                  <p className="text-xs font-proxima-semibold text-greyText text-center">
                                    Click here to upload images
                                  </p>
                                  <p className="text-xs font-proxima-regular text-greyText text-center mt-1">
                                    (JPG, JPEG, PNG)
                                  </p>
                                </div>
                              </div>
                            </div>
                            {imageList.map((image, index) => (
                              <div className="col-span-1 relative" key={index}>
                                <img
                                  src={image["data_url"]}
                                  className="w-full h-productImage object-cover rounded-md"
                                  alt="Product"
                                />
                                <div className="absolute top-2 right-2">
                                  <Button
                                    className="p-2 rounded-full shadow-none hover:shadow-none bg-white border border-logoYellow"
                                    onClick={() => onImageRemove(index)}
                                  >
                                    <FiTrash className="w-3 h-3 text-black" />
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </ReactImageUploading>
                    )}
                  </div>

                  {/* BACK IMAGE */}
                  <div className="p-5 border-t border-authBorder">
                    <div className="block xl:flex lg:flex items-center justify-between">
                      <div>
                        <h5 className="text-lg font-proxima-bold text-black mb-3">
                          Back Image
                        </h5>
                      </div>
                      {productBackImages?.length > 0 && (
                        <div className="flex items-center gap-2  xl:mt-0 lg:mt-0">
                          <Button
                            onClick={() => {
                              handleAddProductImage("back");
                            }}
                            disabled={uploading}
                            className="w-full xl:w-auto lg:w-auto whitespace-nowrap xl:whitespace-normal lg:whitespace-normal shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-4 py-2 rounded-md border border-logoYellow text-xs font-proxima-semibold text-white normal-case transition-all duration-300 ease-in-out"
                          >
                            {uploading ? "Please wait..." : "Upload Image"}
                          </Button>
                        </div>
                      )}
                    </div>
                    {productDetails?.image?.back?.url ? (
                      <div className="grid grid-cols-2 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                        <div className="col-span-1 relative">
                          <img
                            src={IMAGE_URL+productDetails?.image?.back?.url}
                            className="w-full h-productImage object-cover rounded-md"
                            alt="Product"
                          />
                          <div className="absolute top-2 right-2">
                            <Button
                              className="p-2 rounded-full shadow-none hover:shadow-none bg-white border border-logoYellow"
                              onClick={() => handleRemoveImage("back")}
                            >
                              <FiTrash className="w-3 h-3 text-black" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <ReactImageUploading
                        multiple
                        value={productBackImages}
                        onChange={onBackImageChange}
                        maxNumber={5}
                        dataURLKey="data_url"
                      >
                        {({ imageList, onImageUpload, onImageRemove }) => (
                          <div className="grid grid-cols-2 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                            <div className="col-span-1">
                              <div
                                className="w-full h-productImage rounded-md bg-[#F5F5F5] bg-opacity-50 border border-authBorder cursor-pointer hover:border-logoYellow transition-all duration-300 ease-in-out p-5"
                                onClick={onImageUpload}
                              >
                                <AiFillPlusCircle className="w-8 h-8 text-greyText mx-auto" />
                                <div className="mt-2">
                                  <p className="text-xs font-proxima-semibold text-greyText text-center">
                                    Click here to upload images
                                  </p>
                                  <p className="text-xs font-proxima-regular text-greyText text-center mt-1">
                                    (JPG, JPEG, PNG)
                                  </p>
                                </div>
                              </div>
                            </div>
                            {imageList.map((image, index) => (
                              <div className="col-span-1 relative" key={index}>
                                <img
                                  src={image["data_url"]}
                                  className="w-full h-productImage object-cover rounded-md"
                                  alt="Product"
                                />
                                <div className="absolute top-2 right-2">
                                  <Button
                                    className="p-2 rounded-full shadow-none hover:shadow-none bg-white border border-logoYellow"
                                    onClick={() => onImageRemove(index)}
                                  >
                                    <FiTrash className="w-3 h-3 text-black" />
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </ReactImageUploading>
                    )}
                  </div>

                  {/* OTHER IMAGES */}
                  <div className="p-5 border-t border-authBorder">
                    <div className="block xl:flex lg:flex items-center justify-between">
                      <div>
                        <h5 className="text-lg font-proxima-bold text-black mb-3">
                          Other Image
                        </h5>
                      </div>
                      {productOthersImages?.length > 0 && (
                        <div className="flex items-center gap-2 mb-2 xl:mt-0 lg:mt-0">
                          <Button
                            onClick={() => {
                              handleAddProductImage("others");
                            }}
                            disabled={uploading}
                            className="w-full xl:w-auto lg:w-auto whitespace-nowrap xl:whitespace-normal lg:whitespace-normal shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-4 py-2 rounded-md border border-logoYellow text-xs font-proxima-semibold text-white normal-case transition-all duration-300 ease-in-out"
                          >
                            {uploading ? "Please wait..." : "Upload Image"}
                          </Button>
                        </div>
                      )}
                    </div>

                    <ReactImageUploading
                      multiple
                      value={productOthersImages}
                      onChange={onOtherImageChange}
                      maxNumber={5}
                      dataURLKey="data_url"
                    >
                      {({ imageList, onImageUpload, onImageRemove }) => (
                        <div className="grid grid-cols-2 xl:grid-cols-3 lg:grid-cols-3 gap-5">
                          {productDetails?.image?.others?.map(
                            (element, index) => {
                              return (
                                <div
                                  className="col-span-1 relative"
                                  key={index}
                                >
                                  <img
                                    src={IMAGE_URL+element?.url}
                                    className="w-full h-productImage object-cover rounded-md"
                                    alt="Product"
                                  />
                                  <div className="absolute top-2 right-2">
                                    <Button
                                      className="p-2 rounded-full shadow-none hover:shadow-none bg-white border border-logoYellow"
                                      onClick={() =>
                                        handleRemoveImage(element?._id)
                                      }
                                    >
                                      <FiTrash className="w-3 h-3 text-black" />
                                    </Button>
                                  </div>
                                </div>
                              );
                            }
                          )}
                          <div className="col-span-1">
                            <div
                              className="w-full h-productImage rounded-md bg-[#F5F5F5] bg-opacity-50 border border-authBorder cursor-pointer hover:border-logoYellow transition-all duration-300 ease-in-out p-5"
                              onClick={onImageUpload}
                            >
                              <AiFillPlusCircle className="w-8 h-8 text-greyText mx-auto" />
                              <div className="mt-2">
                                <p className="text-xs font-proxima-semibold text-greyText text-center">
                                  Click here to upload images
                                </p>
                                <p className="text-xs font-proxima-regular text-greyText text-center mt-1">
                                  (JPG, JPEG, PNG)
                                </p>
                              </div>
                            </div>
                          </div>
                          {imageList.map((image, index) => (
                            <div className="col-span-1 relative" key={index}>
                              <img
                                src={image["data_url"]}
                                className="w-full h-productImage object-cover rounded-md"
                                alt="Product"
                              />
                              <div className="absolute top-2 right-2">
                                <Button
                                  className="p-2 rounded-full shadow-none hover:shadow-none bg-white border border-logoYellow"
                                  onClick={() => onImageRemove(index)}
                                >
                                  <FiTrash className="w-3 h-3 text-black" />
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </ReactImageUploading>
                  </div>
                </div>

                {/* SPECIAL DISCOUNTS */}
                <div className="bg-white mt-5 rounded-lg border border-authBorder">
                  <div className="px-5 py-3 border-b border-authBorder">
                    <h5 className="text-lg font-proxima-bold text-black">
                      Special Discounts
                    </h5>
                    <p className="text-sm font-proxima-regular text-greyText">
                      Enter the special price as well as the start date and end
                      date
                    </p>
                  </div>
                  <div className="p-5">
                    <div className="form-group">
                      <label className="text-sm font-proxima-semibold text-black">
                        Special Price
                      </label>
                      <div className="mt-1">
                        <InputField
                          type="number"
                          name="specialAmount"
                          id="specialAmount"
                          placeholder="Write the special price"
                          onChange={editFormikFunction.handleChange}
                          value={editFormikFunction.values.specialAmount}
                          error={
                            editFormikFunction.errors.specialAmount &&
                            editFormikFunction.touched.specialAmount
                              ? true
                              : false
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-5 grid grid-cols-2 gap-5">
                      <div className="col-span-1">
                        <div className="form-group">
                          <label className="text-sm font-proxima-semibold text-black">
                            Start Date
                          </label>
                          <div className="mt-1">
                            <ReactDatePicker
                              selected={
                                editFormikFunction.values.specialAmountStartDate
                              }
                              error={
                                editFormikFunction.errors
                                  .specialAmountStartDate &&
                                editFormikFunction.touched
                                  .specialAmountStartDate
                                  ? true
                                  : false
                              }
                              onChange={(date) =>
                                editFormikFunction.setFieldValue(
                                  "specialAmountStartDate",
                                  date
                                )
                              }
                              calendarClassName="calendar"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="form-group">
                          <label className="text-sm font-proxima-semibold text-black">
                            End Date
                          </label>
                          <div className="mt-1">
                            <ReactDatePicker
                              selected={
                                editFormikFunction.values.specialAmountEndDate
                              }
                              error={
                                editFormikFunction.errors
                                  .specialAmountEndDate &&
                                editFormikFunction.touched.specialAmountEndDate
                                  ? true
                                  : false
                              }
                              onChange={(date) =>
                                editFormikFunction.setFieldValue(
                                  "specialAmountEndDate",
                                  date
                                )
                              }
                              calendarClassName="calendar"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 
                <div className="mt-5 bg-white rounded-lg border border-authBorder">
                  <div className="px-5 py-3 border-b border-authBorder">
                    <h5 className="text-lg font-proxima-bold text-black">
                      Meta Titles
                    </h5>
                    <p className="text-sm font-proxima-regular text-greyText">
                      Enter the meta titles, descriptions and keywords for this product
                    </p>
                  </div>
                  <div className="p-5">

                    <div className="grid grid-cols-2 gap-5">
                      <div className="col-span-1">
                        <div className="form-group">
                          <label className="text-sm font-proxima-semibold text-black">
                            Title
                          </label>
                          <div className="mt-1">
                            <InputField
                              type="text"
                              name="metaTagsTitle"
                              id="metaTagsTitle"
                              onChange={editFormikFunction.handleChange}
                              value={editFormikFunction.values.metaTagsTitle}
                              error={editFormikFunction.errors.metaTagsTitle && editFormikFunction.touched.metaTagsTitle ? true : false}
                              placeholder="Write the Meta Title"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div className="form-group">
                          <label className="text-sm font-proxima-semibold text-black">
                            Keywords
                          </label>
                          <div className="mt-1">
                            <InputField
                              type="text"
                              name="metaTagsKeyWords"
                              id="metaTagsKeyWords"
                              onChange={editFormikFunction.handleChange}
                              value={editFormikFunction.values.metaTagsKeyWords}
                              error={editFormikFunction.errors.metaTagsKeyWords && editFormikFunction.touched.metaTagsKeyWords ? true : false}
                              placeholder="Write the Meta Keywords"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 form-group">
                      <label className="text-sm font-proxima-semibold text-black">
                        Description
                      </label>
                      <div className="mt-1">
                        <InputField
                          type="text"
                          name="metaTagsDescription"
                          id="metaTagsDescription"
                          onChange={editFormikFunction.handleChange}
                          value={editFormikFunction.values.metaTagsDescription}
                          error={editFormikFunction.errors.metaTagsDescription && editFormikFunction.touched.metaTagsDescription ? true : false}
                          placeholder="Write the Meta Description"
                        />
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default EditProduct;
